import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './styles.sass'

class SimpleSearchForm extends Component {
  static propTypes = {
    mini: PropTypes.bool,
  }

  render() {
    return (
      <div>
        {this.props.mini ? (
          <div className='simple-search-form'>
            <div className='row no-margin'>
              <div className='col-4' id='brand'>
                <span className='value' />
              </div>
              <div className='col-4' id='model'>
                <span className='value' />
              </div>
              <div className='col-4' id='year'>
                <span className='label medium' />
                <span className='value medium' />
                <span className='value medium' />
              </div>
              <div className='col-4'>
                <span className='value' />
              </div>
            </div>
          </div>
        ) : (
          <div className='simple-search-form'>
            <div className='row'>
              <div className='col-4' id='brand'>
                <span className='value' />
              </div>
              <div className='col-4' id='model'>
                <span className='value' />
              </div>
              <div className='col-4' id='year'>
                <span className='label medium' />
                <span className='value medium' />
                <span className='value medium' />
              </div>
              <div className='col-4' id='price'>
                <span className='label small' />
                <span className='value long' />
                <span className='value long' />
              </div>
            </div>
            <div className='row'>
              <div className='col-4' id='km'>
                <span className='label small' />
                <span className='value long' />
                <span className='value long' />
              </div>
              <div className='col-4' id='fuel'>
                <span className='label medium' />
                <span className='value' />
              </div>
              <div className='col-4' id='gear'>
                <span className='label medium' />
                <span className='value' />
              </div>
              <div className='col-4' id='location'>
                <span className='label small' />
                <span className='value small' />
                <span className='value' />
              </div>
            </div>
            <div className='row' id='actions'>
              <div className='col-6'>
                <span className='reset' />
              </div>
              <div className='col-6'>
                <span className='advanced-search' />
                <span className='search' />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default SimpleSearchForm
